import React from 'react';
import PropTypes from 'prop-types';
import icons from './icons.svg';
import './IconSVG.scss';

const IconSVG = props => (
  <div
    className={`icon-svg__wrapper ${
      props.background ? `icon-svg--background-${props.background}` : ''
    } icon-svg__wrapper--${props.size} ${props.additionalClass}`}
  >
    <svg
      className={`icon-svg icon-svg-${props.name} icon-svg--color-${
        props.color
      }`}
    >
      <use xlinkHref={`${icons}#icon-${props.name}`} />
    </svg>
  </div>
);

IconSVG.defaultProps = {
  size: 'medium',
  color: 'black',
  background: '',
};

IconSVG.propTypes = {
  name: PropTypes.string.isRequired,
  size: PropTypes.string,
  color: PropTypes.string,
  background: PropTypes.string,
};

export default IconSVG;
